import React, { useState } from 'react';
import Header from '../Header/Header'
import Footer from '../Footer/Footer'
import Home from '../Home/Home'
import './App.scss';
import "../../static/fonts/heebo/stylesheet.css";
import Votes from '../Votes/Votes';
import Thanks from '../Thanks/Thanks';
import { getCookie } from '../../static/helper';

function App() {
  const [section, setSection] = useState("home");
  const [oneTimeDisplay, setOneTimeDisplay] = useState(false);
  const getSection = () => {
    switch (section) {
      case "home":
        return <Home oneTimeDisplay={oneTimeDisplay} setPageSection={setPageSection} />
      case "votes":
        return <Votes setPageSection={setPageSection} />;
      case "thanks":
        return <Thanks />;
      default:
        return <Home />
    }
  }

  const setPageSection = (section) => {
    if (section === "votes") {
      if (localStorage.getItem("dpaevfv_teu")) {
        setOneTimeDisplay(true);
        return;
      }
    }
    setSection(section);
  }

  return (
    <div className="App">
      <div className="body-container">
        {getSection()}
      </div>
      <Footer />
    </div>
  );
}

export default App;
